





























































import { confirmDelete } from '@/libs/decorator';
import { getRange } from '@/libs/time';
import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import MyDoneServices from '@/services/mydone';
import moment from 'moment';
import { mixins } from 'vue-class-component';
import { Vue, Component, Watch } from 'vue-property-decorator';
@Component
export default class Todo extends mixins(DictMixin, PageMixin) {
  doneSrv = new MyDoneServices();

  created() {
    this.getAll();
  }

  count: any = {};
  async getAll() {
    this.loading = true;
    let [startTime, endTime] = this.date;
    this.count = await this.doneSrv.getReqCount({ startTime, endTime });
    this.params = { startTime, endTime };
    await this.getList();
    this.loading = false;
  }

  params: any = {};

  async getList() {
    let res = await this.doneSrv.getReqPage({ ...this.params, page: this.page, limit: this.limit });
    this.dataSource = res.records;
    this.total = res.total;
  }

  async getCurrentList(type: number) {
    this.page = 1;
    this.loading = true;
    let [startTime, endTime] = this.date;
    if (type === 0) {
      this.params = { startTime, endTime, appStatus_ge: 2, appStatus_le: 3 };
    } else {
      this.params = { endTime, appStatus_ge: 2, appStatus_le: 3, appDueDate_lt: endTime };
    }
    this.getList();
    this.loading = false;
  }

  @confirmDelete('是否确认撤回该申请')
  async recall(record: any) {
    let res = await this.doneSrv.recall(record);
    if (res) {
      this.$message.success('操作成功');
      this.getAll();
    }
  }

  date: any = getRange('week');
  @Watch('date')
  onDateChange() {
    this.getAll();
  }

  columns = [
    { title: '任务编号', dataIndex: 'appTaskCode' },
    { title: '任务类别', dataIndex: 'appTaskKind' },
    { title: '任务内容', dataIndex: 'appTaskComment' },
    { title: '申请日期', dataIndex: 'requestDate' },
    { title: '审批期限', dataIndex: 'appDueDate' },
    { title: '审批状态', dataIndex: 'appStatus', customRender: (text: string) => this.DICT_VALUE('DICT_APPROVE_STATUS', text) },
    {
      title: '操作',
      dataIndex: 'action',
      width: 180,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  dataSource = [];
}
